import CustomButton from 'components/Button';
import { Download } from '@mui/icons-material';
import { useReactToPrint } from 'react-to-print';

import PropTypes from 'prop-types';

const SaveScreenshot = ({ setShowLoader, displayText, enableBtn, contentRef }) => {
  const handlePrint = useReactToPrint({
    contentRef
  });

  const printWithLoaderEffect = () => {
    setShowLoader(true);
    handlePrint();
    setTimeout(() => {
      setShowLoader(false);
    }, [2000]);
  };

  return (
    <CustomButton
      disableRipple
      sx={{ textAlign: 'left', pl: 0, ml: 0 }}
      add={true}
      endIcon={<Download />}
      disabled={!enableBtn}
      onClick={printWithLoaderEffect}>
      {displayText}
    </CustomButton>
  );
};
SaveScreenshot.propTypes = {
  elementId: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  displayText: PropTypes.string,
  setShowLoader: PropTypes.func,
  enableBtn: PropTypes.bool,
  contentRef: PropTypes.func
};

export default SaveScreenshot;
